import {
  Box,
  Button,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";

export default function CreatedByFilterPopover({
  value,
  onValueChange,
  onClose,
  onClear,
}) {
  return (
    <Box sx={{ minWidth: 150, width: 250, p: 0, m: 0, pb: 0 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.5,
          pt: 0.5,
          pb: 1,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold", color: "#111827" }}>
          Filter By Category
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ p: 0.5, color: "#6B7280" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider sx={{ width: "100%", m: 0, p: 0 }} />

      <Typography
        variant="body2"
        sx={{
          px: 1.5,
          pt: 1.5,
          pb: 1,
          color: "#627CFB",
          fontWeight: 500,
          fontSize: "0.875rem",
        }}
      >
        Category
      </Typography>

      <FormControl fullWidth sx={{ px: 1.5, mb: 1.5 }}>
        <InputLabel sx={{ color: "#9CA3AF", fontSize: "0.875rem" }}>
          Select Category
        </InputLabel>
        <Select
          value={value || ""}
          onChange={(e) => onValueChange(e.target.value)}
          label="Select Category"
          IconComponent={ExpandMoreIcon}
          renderValue={(selected) => (
            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
              {selected}
            </Typography>
          )}
          sx={{
            fontSize: "0.875rem",
            width: "100%",
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#D1D5DB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#627CFB",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#627CFB",
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                zIndex: 99999,
                width: "auto",
              },
            },
            style: {
              zIndex: 99999,
            },
          }}
        >
          <MenuItem value="" sx={{ py: 1, px: 1.5 }}>
            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
              All Categories
            </Typography>
          </MenuItem>
          <MenuItem value="Internal" sx={{ py: 1, px: 1.5 }}>
            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
              Internal
            </Typography>
          </MenuItem>
          <MenuItem value="External" sx={{ py: 1, px: 1.5 }}>
            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
              External
            </Typography>
          </MenuItem>
        </Select>
      </FormControl>

      {Boolean(value) && typeof onClear === "function" && (
        <Button
          onClick={onClear}
          size="small"
          sx={{
            mt: 1,
            color: "#627CFB",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            "&:hover": {
              backgroundColor: "rgba(98, 124, 251, 0.04)",
            },
          }}
        >
          Clear Filter
        </Button>
      )}
    </Box>
  );
}
